import styled from "styled-components/macro";

const Alert = styled.div`
  padding: 16px;
  border: 1px solid transparent;
  border-radius: 6px;
  text-align: left;
  font-size: 14px;
  font-weight: 500;
`;

export const SuccessAlert = styled(Alert)`
  background-color: #daf0fa;
  border-color: #a6daf3;
  color: #676163;
`;

export const WarningAlert = styled(Alert)`
  background-color: #fcf8e3;
  border-color: #faebcc;
  color: #8a6d3b;
`;
